var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7721 12.0027V16.47C19.7721 17.2725 19.412 18.0081 18.824 18.4495C17.372 19.5195 14.9961 20.7901 11.8761 20.7901C10.4601 20.7901 7.67606 20.4825 4.92806 18.4361C4.34006 18.0081 3.99207 17.2725 3.99207 16.47V12.0161L5.79207 12.8988L10.6521 15.3197C10.9281 15.4668 11.1921 15.5204 11.3361 15.5337C11.6961 15.614 12.0561 15.614 12.3921 15.5471C12.5601 15.5204 12.8241 15.4668 13.1001 15.3197L17.9721 12.8988L19.7721 12.0027Z",
    fill: "#959FA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 18.8774C24.5 19.827 23.996 20.6563 23.264 21.0308V22.9969C23.264 23.5586 22.856 24 22.364 24C21.86 24 21.464 23.5586 21.464 22.9969V21.0308C20.732 20.6563 20.228 19.827 20.228 18.8774C20.228 17.9278 20.732 17.0985 21.464 16.724V9.26067L19.772 10.1033L17.972 10.9994L13.1 13.4203C12.824 13.5674 12.56 13.6209 12.392 13.6477C12.056 13.7145 11.696 13.7145 11.336 13.6343C11.192 13.6209 10.928 13.5674 10.652 13.4203L5.792 10.9994L3.992 10.1167L1.90402 9.0734C1.04002 8.6454 0.5 7.8028 0.5 6.85317C0.5 5.90353 1.04002 5.04747 1.90402 4.61946L10.664 0.272548C11.432 -0.0885799 12.32 -0.0885929 13.076 0.25916L21.86 4.61946C22.724 5.04747 23.264 5.90353 23.264 6.85317V16.724C23.996 17.0985 24.5 17.9278 24.5 18.8774Z",
    fill: "#959FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/graduation.077d241700d9ba5d97b973a160317a77.svg";
export { ForwardRef as ReactComponent };